import React from 'react';
import { CampaignCard } from './CampaignCard';
import { Campaign } from '../data/mockData';
interface CampaignGridProps {
  campaigns: Campaign[];
}
export function CampaignGrid({
  campaigns
}: CampaignGridProps) {
  if (campaigns.length === 0) {
    return <div className="bg-card border border-border rounded-2xl p-12 text-center shadow-sm" data-id="element-49">
        <h3 className="text-lg font-semibold text-foreground mb-2" data-id="element-50">
          Ni najdenih kampanj
        </h3>
        <p className="text-muted-foreground" data-id="element-51">
          Poskusite spremeniti filtre za prikaz rezultatov.
        </p>
      </div>;
  }
  return <div className="grid grid-cols-1 xl:grid-cols-2 gap-6" data-id="element-52">
      {campaigns.map(campaign => <CampaignCard key={campaign.id} campaign={campaign} data-id="element-53" />)}
    </div>;
}